import { ObstacleType } from "../Data/Obstacles";

export class ProjectileToken {
    public readonly type: ObstacleType;
    public readonly pos: PIXI.Point;

    constructor(pType: ObstacleType, pPos: PIXI.Point) {
        this.type = pType;
        this.pos = pPos;
    }
}
